<template>
  <button
    v-on:click="$emit('payment-click')"
    :disabled="sendingOrder"
    class="next-step-button button">
      <div class="loader"><div></div><div></div><div></div><div></div></div>
      Przejdź do płatności
  </button>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PaymentButton',
  computed: {
    ...mapState([
      'sendingOrder'
    ])
  }
}
</script>
